'use client'

import { ImageMeta } from './useImage'
import { cn } from '@/utilities/ui'
import { PixelationState, ResponsiveParams } from './lib/types'

interface Props {
  canvasContainerRef: React.RefObject<HTMLDivElement | null>
  containerRef: React.RefObject<HTMLDivElement | null>
  imageMeta: ImageMeta | null
  canvasRef: React.RefObject<HTMLCanvasElement | null>
  params: ResponsiveParams | null
  state: PixelationState
  className?: string
}

export function Pixelator({
  containerRef,
  canvasContainerRef,
  imageMeta,
  canvasRef,
  params,
  state,
  className,
}: Props) {
  const showBorder = params && state.currentStep !== 'zoom'
  return (
    <div
      ref={containerRef}
      className={cn('w-full h-full flex items-center justify-start', className)}
    >
      {imageMeta && (
        <div
          key={`${imageMeta.width}-${imageMeta.height}`}
          className={cn('relative border-4 border-transparent', showBorder && 'border-punch')}
        >
          <div
            ref={canvasContainerRef}
            className="overflow-hidden"
            style={{
              width: params?.width,
              height: params?.height,
            }}
          >
            <canvas
              ref={canvasRef}
              style={{
                width: params?.width,
                height: params?.height,
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
